import Controller from "./backupSchedules.controller";
import template from "./backupSchedules.html";

const backupSchedules = {
  template,
  controller: Controller,
};

export default backupSchedules;



// WEBPACK FOOTER //
// ./src/pages/backupSchedules/backupSchedules.component.js